import { SVGProps } from 'react'

export const CalculateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.3333 3H4.66667C3.75 3 3 3.75 3 4.66667V16.3333C3 17.25 3.75 18 4.66667 18H16.3333C17.25 18 18 17.25 18 16.3333V4.66667C18 3.75 17.25 3 16.3333 3ZM16.3333 16.3333H4.66667V4.66667H16.3333V16.3333Z" />
      <path d="M9.875 6.93333H5.70833V8.18333H9.875V6.93333Z" />
      <path d="M15.5 13.625H11.3333V14.875H15.5V13.625Z" />
      <path d="M15.5 11.5417H11.3333V12.7917H15.5V11.5417Z" />
      <path d="M7.16667 15.5H8.41667V13.8333H10.0833V12.5833H8.41667V10.9167H7.16667V12.5833H5.5V13.8333H7.16667V15.5Z" />
      <path d="M12.2417 9.625L13.4167 8.45L14.5917 9.625L15.475 8.74167L14.3 7.55833L15.475 6.38333L14.5917 5.5L13.4167 6.675L12.2417 5.5L11.3583 6.38333L12.5333 7.55833L11.3583 8.74167L12.2417 9.625Z" />
    </svg>
  )
}
